export const parseNumber = (value: string | undefined): number => {
  const result = value == null ? 0 : parseFloat(value);
  return Number.isNaN(result) ? 0 : result;
};
